// extracted by mini-css-extract-plugin
module.exports = {"qualityIndicator":"QualityIndicator__qualityIndicator__tZssH","level":"QualityIndicator__level__fQ97J","activeLevel":"QualityIndicator__activeLevel__UG-Cd"};